import { getMasterSurvey } from "@/API/survey/getMasterSurvey";
import { getMasterBook } from "@/API/masterBook/getMasterBook";

/**
 * アンケートに必要なデータを取得する
 * @param {number} masterSurveyId
 * @param {number} masterBookId
 * @returns {Promise<Object>} アンケートマスターデータ
 */
export const fetchSurveyData = async (masterSurveyId, masterBookId) => {
  const masterSurvey = await getMasterSurvey(masterSurveyId);
  // userInfoAcquisitionTermsUrl の算出に masterBook.content が必要なため masterBook を取得する
  await getMasterBook(masterBookId);
  return masterSurvey;
};
